import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import { Alert, Button } from 'react-bootstrap';
import api from '../helpers/ApiClient';
import qs from 'qs';
import Loader from '../components/Loader';

class AnnouncementSG extends Component {

    constructor(props) {
        super(props);
        const { location } = props;
        let discountCode
        let discountDesc
        let announcement
        let loading = false;

        this.state = {
            announcement,
            discountCode,
            discountDesc,
            loading
        };
    }

    componentWillMount(){
    }

    componentDidMount() {        
        this.getAnnouncement()
    }

    getAnnouncement = () => {

        const { params: { vendor } } = this.props;

        this.setState({ loading: true });

        return api(`/api/lookup/sg/announcement/${vendor.replace('&', '').replace('’', '')}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(result => {

            this.setState({ loading: false });

            if(result){
                this.setState({ 
                    announcement: result.announcement,
                    discountCode: result.discountcode,
                    discountDesc: result.discountdesc });        
            } else {
                this.setState({ 
                    invalidPostcode: true,
                    result: undefined
                 });        
            }
        })
    }

    handlePostcodeChange = (event) => {
        this.setState({ postcode: event.target.value });
    }

    render() {
        const { error } = this.props
        const { announcement, discountCode, discountDesc, loading, invalidPostcode } = this.state;
    
        return (
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div>
                            {
                                error &&
                                <Alert bsStyle="danger">
                                    <div>{error}</div>
                                </Alert>
                            }
                            {
                                loading &&
                                <Loader />
                            }
                            {
                                !loading && announcement &&
                                <div>
                                    <label className="announcement-label">Announcement</label>
                                    <p>{announcement}</p>
                                </div>
                            }
                            {
                                !loading && discountCode &&
                                <div>
                                    <div><span className="announcement-discount-code">CODE: {discountCode}</span> { discountDesc && <span className="announcement-discount-code-desc">{discountDesc}</span>}</div>
                                </div>
                            }
                            {
                                invalidPostcode &&
                                <div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect((state, props) => {

    return {
        
    };
})(AnnouncementSG);